import React from 'react';
import { FormGroup, Label } from 'reactstrap';

export default function DateRangePicker({ dateFrom, dateTo, onChangeFrom, onChangeTo }) {
  const invalidRange = dateFrom && dateTo && dateTo < dateFrom;

  return (
    <div className="d-flex gap-2 align-items-end flex-wrap">
      <FormGroup className="mb-0">
        <Label className="col-form-label" for="date-from">
          From
        </Label>
        <input
          id="date-from"
          type="date"
          className="form-control form-control-sm"
          value={dateFrom}
          onChange={(e) => onChangeFrom(e.target.value)}
          max={dateTo || undefined}
        />
      </FormGroup>
      <FormGroup className="mb-0">
        <Label className="col-form-label" for="date-to">
          To
        </Label>
        <input
          id="date-to"
          type="date"
          className={`form-control form-control-sm${invalidRange ? ' is-invalid' : ''}`}
          value={dateTo}
          onChange={(e) => onChangeTo(e.target.value)}
          min={dateFrom || undefined}
          aria-invalid={invalidRange}
        />
        {invalidRange && (
          <div className="invalid-feedback d-block">To must be on or after From</div>
        )}
      </FormGroup>
    </div>
  );
}
